import { useState } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import PopoverButtonsGroup from 'components/new-ui/composed/popover-buttons-group/PopoverButtonsGroup';
import { StyledPopoverButton } from 'components/new-ui/composed/popover-buttons-group/styles';

type Props = {
    onDuplicate?: () => void;
    onDownloadPdf?: () => void;
    onArchive?: () => void;
    onUnarchive?: () => void;
};

const ActionsButtonWithPopover = ({ onDuplicate, onDownloadPdf, onArchive, onUnarchive }: Props) => {
    const [open, setOpen] = useState(false);

    // Closes the popover when an action is triggered
    const withClose =
        <T extends any[]>(fn?: (...args: T) => void) =>
        (...args: T) => {
            const e = args[0] as any;
            if (e && typeof e.stopPropagation === 'function') {
                e.stopPropagation();
            }

            fn?.(...args);
            setOpen(false);
        };

    return (
        <>
            <PopoverButtonsGroup
                open={open}
                onOpenChange={(next) => setOpen(next)}
                buttonEl={
                    <IconButton
                        icon={<MoreOutlined />}
                        tooltipText="Actions"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(true);
                        }}
                    />
                }
            >
                {onDuplicate && (
                    <StyledPopoverButton onClick={withClose(onDuplicate)}>Duplicate invoice</StyledPopoverButton>
                )}
                {onDownloadPdf && (
                    <StyledPopoverButton onClick={withClose(onDownloadPdf)}>Download PDF</StyledPopoverButton>
                )}
                {onArchive && <StyledPopoverButton onClick={withClose(onArchive)}>Archive</StyledPopoverButton>}
                {onUnarchive && <StyledPopoverButton onClick={withClose(onUnarchive)}>Unarchive</StyledPopoverButton>}
            </PopoverButtonsGroup>
        </>
    );
};

export default ActionsButtonWithPopover;
